module.exports = {
  wwwBaseUrl: 'https://www.mytcas.com',
  apiBaseUrl: 'https://my-tcas.s3.ap-southeast-1.amazonaws.com/mytcas',
  apiVenueUrl: 'https://assets.mytcas.com/70',
  // apiVenueUrl: '/data',
  previewBaseUrl: 'https://tcas65.as.r.appspot.com',
};
